import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance3ftsl9x5arf2y as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      x6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.k6w_1);
        writer.l4d('playerId');
        get_playerIdAdapter().q40(writer, customScalarAdapters, value.l6w_1);
        writer.l4d('name');
        get_StringAdapter().q40(writer, customScalarAdapters, value.m6w_1);
        writer.l4d('email');
        get_StringAdapter().q40(writer, customScalarAdapters, value.n6w_1);
        writer.l4d('badge');
        Badge_ResponseAdapter_instance.v6p(writer, customScalarAdapters, value.o6w_1);
        writer.l4d('callSignAdjective');
        get_StringAdapter().q40(writer, customScalarAdapters, value.p6w_1);
        writer.l4d('callSignNoun');
        get_StringAdapter().q40(writer, customScalarAdapters, value.q6w_1);
        var tmp = value.r6w_1;
        if (tmp instanceof Present()) {
          writer.l4d('imageURL');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.r6w_1);
        }
        var tmp_0 = value.s6w_1;
        if (tmp_0 instanceof Present()) {
          writer.l4d('avatarType');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.s6w_1);
        }
        writer.l4d('unvalidatedEmails');
        list(get_StringAdapter()).m41(writer, customScalarAdapters, value.t6w_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.x6x(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance3fw9b8k7xujxv,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
